// Firebase Imports
import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import {
  getFirestore,
  collection,
  addDoc,
  getDoc,
  doc,
  query,
  where,
  getDocs,
  DocumentData,
} from 'firebase/firestore'
import { Search } from 'types/search'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIRECASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)
export const analytics = getAnalytics(app)
export const db = getFirestore(app)
export default app

// Endpoints
export const createSearch = async (search: Search) => {
  await addDoc(collection(db, 'searches'), {
    ...search,
  })
}

export const getSearches = async (userId: string) => {
  const searchRef = collection(db, 'searches')

  const q = query(searchRef, where('userId', '==', userId))

  const querySnapshot = await getDocs(q)
  const searches: DocumentData[] = []

  await querySnapshot.forEach((doc) => {
    searches.push({ ...doc.data(), id: doc.id })
  })

  return searches
}

export const getSearch = async (searchId: string) => {
  const search = await getDoc(doc(db, 'searches', searchId))

  if (search.exists()) {
    return search.data()
  }
  return null
}
